import Vue from "vue";

Vue.filter("formatUnixEpocTimePart", (value: Date) => {
  if (value) return Intl.DateTimeFormat("en-GB", { hour: "numeric", minute: "numeric", hour12: false }).format(new Date(value));
});

Vue.filter("formatUnixEpocDayPart", (value: Date) => {
  if (value) return Intl.DateTimeFormat("en-GB", { month: "long", day: "numeric", year: "numeric" }).format(new Date(value));
});
